import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import ToggleField from '../../ToggleField/ToggleField';

import logo from '../../../assets/images/integrations/ozu.webp';

const OzuFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="OzuFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" alt={t('settings.integrations.ozu.title')} />
                                { t('settings.integrations.ozu.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.ozu.url")}</Label>
                                            <Col lg={10} >
                                                <Field component="input" className="form-control" type="url" name="integrations.ozu.url" id="url" pattern="https://.*" />
                                                <small className="text-muted d-block mt-1">
                                                    { t('settings.integrations.ozu.url_optional_hint') }
                                                </small>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>

                        <CardBody>
                            <CardTitle className="small">{ t('settings.integrations.ozu.import.title') }</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.ozu.import.screenings.title")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.ozu.import.screenings.enabled" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.ozu.import.screenings.delete_future")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.ozu.import.screenings.delete_future" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.ozu.import.screenings.delete_existing")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.ozu.import.screenings.delete_existing" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default OzuFields;
